module.exports = __webpack_public_path__ + "img/bakery-banner.656d2263.png";